<template>
    <div>
        <modalconfirm ref="modalCancelTransaction" @action="processCancel" />
        <div class="text-h5">Pembatalan Transaksi</div>
        <v-alert type="info" class="my-3">
            Pastikan bahwa <strong>Kode Transaksi</strong> yang dimasukkan sudah benar
        </v-alert>
        <v-alert type="error" class="my-3">
            <strong>Perhatian!</strong> Pembatalan transaksi tidak dapat <strong>dibatalkan</strong>. Pastikan Anda sudah yakin untuk membatalkan
            transaksi ini.
        </v-alert>
        <v-form ref="formCancel" role="form">
            <v-card class="mt-3 mb-3" outlined>
                    <v-card-text class="pt-2 pb-0">
                        <v-row class="flex-column">
                            <v-col cols="12" md="6" class="pb-0">
                                <v-text-field outlined dense v-model="code" label="Kode Transaksi" prepend-icon="mdi-barcode"
                                    @focus="() => responseError.code = ''" :error-messages="responseError.code"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="px-4 pb-4 col-6 justify-end">
                        <v-btn light depressed color="primary" @click="submitCheckTransaction">
                            <v-icon>mdi-shield-check</v-icon>
                            <div class="pl-2 text-capitalize">Cek Transaksi</div>
                        </v-btn>
                    </v-card-actions>
            </v-card>
            <v-card class="mb-3" outlined v-if="detailTransaction.results">
                <v-list color="deep-purple lighten-5" class="pt-0 pb-0">
                    <v-list-item dense>
                        <v-list-item-content class="grey--text text--darken-2">
                            TRX{{ detailTransaction.results.data.trx_code }}
                        </v-list-item-content>
                        <v-spacer></v-spacer>
                    </v-list-item>
                </v-list>
                <v-list-item>
                    <v-list-item-content>
                        <v-layout wrap>
                            <v-flex xs6 sm3 md3>
                                <div class="body-2 oppacity-75">Stockist</div>
                                <div class="subtitle-2">{{ detailTransaction.results.data.stockist_code }} - {{
                                    detailTransaction.results.data.stockist_name }}</div>
                            </v-flex>
                            <v-flex xs6 sm3 md3>
                                <div class="body-2 oppacity-75">Pembeli</div>
                                <div class="subtitle-2">{{ detailTransaction.results.data.trx_buyer_sponsor_network_mid }} - {{
                                    detailTransaction.results.data.trx_buyer_name }}</div>
                            </v-flex>
                            <v-flex xs6 sm3 md3>
                                <div class="body-2 oppacity-75">Tipe Pembayaran</div>
                                <div class="subtitle-2 text-capitalize">{{ detailTransaction.results.data.trx_payment_method_text }}</div>
                            </v-flex>
                            <v-flex xs6 sm3 md3>
                                <div class="body-2 oppacity-75">Tanggal Transaksi</div>
                                <div class="subtitle-2">{{ detailTransaction.results.data.trx_datetime | tanggaljam }}</div>
                            </v-flex>
                            <v-flex xs6 sm3 md3 class="pt-3">
                                <div class="body-2 oppacity-75">Tipe Produk</div>
                                <div class="subtitle-2">{{ detailTransaction.results.product.length }}</div>
                            </v-flex>
                            <v-flex xs6 sm3 md3 class="pt-3">
                                <div class="body-2 oppacity-75">Jumlah Produk</div>
                                <div class="subtitle-2">{{ allTotalProduct | toNumber }}</div>
                            </v-flex>
                            <v-flex xs6 sm3 md3 class="pt-3">
                                <div class="body-2 oppacity-75">Total Transaksi</div>
                                <div class="subtitle-2">{{ detailTransaction.results.data.trx_price_grand_total | toNumber }}</div>
                            </v-flex>
                        </v-layout>
                    </v-list-item-content>
                </v-list-item>
                <div class="pt-3">
                    <v-card tile elevation="0">
                        <v-data-table :headers="headersProduct" :items="detailTransaction.results.product" :items-per-page="1000" class="elevation-0"
                            hide-default-footer>
                            <template v-slot:item.code="{ item }">
                                <div>{{ item.code }}</div>
                            </template>
                            <template v-slot:item.name="{ item }">
                                <div>{{ item.name }}</div>
                            </template>
                            <template v-slot:item.quantity="{ item }">
                                <div>{{ item.quantity | toNumber }} {{ item.unit }}</div>
                            </template>
                            <template v-slot:item.price_base="{ item }">
                                <div>{{ item.price_base | toNumber }}</div>
                            </template>
                            <template v-slot:item.price_total="{ item }">
                                <div>{{ item.price_total | toNumber }}</div>
                            </template>
                        </v-data-table>
                    </v-card>
                </div>
            </v-card>
            <v-card class="mt-3" outlined v-if="sent.id > 0">
                <v-card-text class="pt-2 pb-0">
                    <v-row class="flex-column">
                        <v-col cols="12" sm="6" md="6">
                            <v-textarea v-model="sent.note" label="Alasan Pembatalan" rows="3" height="120" @focus="() => responseError.note = ''"
                                :error-messages="responseError.note" hide-details="auto" outlined dense no-resize></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="px-4 pb-4 col-12 justify-end">
                    <v-btn light depressed color="error" @click="confirmCancelTransaction">
                        <v-icon>mdi-close-circle-outline</v-icon>
                        <div class="pl-2 text-capitalize">Proses Pembatalan Transaksi</div>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template>

<script>

import { mapActions, mapState, mapMutations } from 'vuex'

export default {
    inject: ['theme'],
    components: {
    },
    data() {
        return {
            code: '',
            isLoading: false,
            sent: {
                id: '',
                note: '',
            },
            headersProduct: [
                { text: 'Kode Produk', value: 'code', sortable: false },
                { text: 'Nama Produk', value: 'name', sortable: false },
                { text: 'Jumlah', value: 'quantity', align: 'center', sortable: false },
                { text: 'Harga', value: 'price_base', align: 'center', sortable: false },
                { text: 'Total Harga', value: 'price_total', align: 'center', sortable: false },
            ],
        }
    },
    computed: {
        ...mapState('ecommerceTransaction', ['detailTransaction', 'response' ,'responseError', 'alert']),
        allTotalProduct() {
            if (this.detailTransaction.results && this.detailTransaction.results.product) {
                return this.detailTransaction.results.product.reduce((total, item) => total + item.quantity, 0)
            }
            return 0
        },
    },
    methods: {
        ...mapActions('ecommerceTransaction', ['getCancelTransaction', 'cancelTransaction']),
        ...mapMutations('ecommerceTransaction', ['setDetailTransaction']),
        ...mapMutations(['setOverlay', 'setSnackbar']),
        async submitCheckTransaction() {
            this.sent.id = ''
            
            await this.setOverlay(true)
            let params = {
                trx_code: this.code
            }
            await this.getCancelTransaction(params).then(() => {
                if (Object.keys(this.detailTransaction).length > 0) {
                    this.setSnackbar({
                        show: true,
                        color: 'success',
                        text: `Data transaksi ditemukan`,
                    })
                    this.sent.id = this.detailTransaction.results.data.trx_id
                }
            })
            await this.setOverlay(false)
        },
        confirmCancelTransaction() {
            if (this.detailTransaction) {
                this.$refs.modalCancelTransaction.setMessage('Apakah Anda yakin akan membatalkan transaksi ini?')
                this.$refs.modalCancelTransaction.setWarning('Transaksi yang sudah dibatalkan tidak dapat dikembalikan lagi.')
                this.$refs.modalCancelTransaction.showConfirm()
            }
        },
        async processCancel() {
            await this.setOverlay(true)
            await this.$refs.modalCancelTransaction.hideConfirm()
            let params = await {
                trx_id: this.sent.id,
                note: this.sent.note,
            }
            await this.cancelTransaction(params).then(() => {            
                if (this.response.code == 200) {
                    this.resetForm()
                }
            })
            await this.setOverlay(false)

        },
        resetForm() {
            this.code = ''
            this.note = ''
            this.sent.id = ''
            this.sent.note = ''
            this.setDetailTransaction({})
        },
    },
    created() {
        this.$store.dispatch('setPageTitle', `Pembatalan Transaksi`)
    },
}
</script>